import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions('appAuth', [
  'appLogIn',
  'companyInfoExists',
])

export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'register',
  'resetPassword',
  'getUser',
  'setUserActiveSection',
])

export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  }),
}

export const languageMethods = mapActions('language', ['setLanguage'])

export const usersComputed = {
  ...mapState('users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions('users', [
  'fetchUsers',
  'createUpdateUsers',
  'deleteUsers',
  'changePassword',
  'updatePhotos',
  'fetchUsersDetail',
  'fetchUsersForOptions',
  'checkIfUserExists',
  'registerUsers',
])

export const permsComputed = {
  ...mapState('perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions('perms', [
  'fetchPerms',
  'createUpdatePerms',
  'deletePerms',
  'fetchPermsDetail',
])

export const groupsComputed = {
  ...mapState('groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions('groups', [
  'fetchGroups',
  'createUpdateGroups',
  'deleteGroups',
  'fetchGroupsDetail',
])

export const appSectionsComputed = {
  ...mapState('appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions('appSections', [
  'fetchAppSections',
  'createUpdateAppSections',
  'deleteAppSections',
  'fetchAppSectionsDetail',
])

export const companyInfoComputed = {
  ...mapState('companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions('companyInfo', [
  'fetchCompanyInfo',
  'createUpdateCompanyInfo',
  'setFileCompanyInfo',
])

// Forms helpers

export const formMethods = mapActions('forms', [
  'createForm',
  'getBaseVariables',
  'getForms',
  'deleteForm',
  'getSecretaries',
  'getIndicators',
  'getProjects',
  'getCommunes',
  'getNeighborhoods',
  'createFormExtVars',
  'getFormsManaged',
  'getFormsManagedById',
  'createFormsManaged',
  'getFormSession',
  'getFormSessions',
  'getCountQueueSessions',
  'setFormSession',
  'getAutoCompleteData',
  'setVariableFile',

])
export const familiesMethods = mapActions('families', [
  'setFamilies',
  'getFamiliesByAdd',
  'getFamiliesByCode',
  'getFamiliesBySearch',
  'getFamiliesByPersonId',
])

export const pollMethods = mapActions('polls' , [
  'createPoll',
  'getBaseVariables',
  'getPolls',
  'getPollswithToken',
  'deletePoll',
  'getSecretaries',
  'getIndicators',
  'getProjects',
  'getCommunes',
  'getNeighborhoods',
  'createPollVars',
  'getPollsManaged',
  'getPollsManagedById',
  'createPollsManaged',
  'getPollSession',
  'getPollSessions',
  'getCountQueueSessions',
  'setPollSession',
  'getAutoCompleteData',
  'setVariableFile',
  'getDimensionsPoll',
  'setPollWithToken',
  'getTokenForPoll',

  

])

export const variablesMethods = mapActions('variables', [
  'createVariable',
  'getVariables',
  'getVariablesList',
  'deleteVariable',
  'getDimensions',
  'getMeasureUnits',
  'getPrivacyLevels',
  'getDimensionsPoll',

])


export const reportsMethods = mapActions('reports', [
  'getReportByIndexVars',
  'getReportByFilterVars',
  'getReportLog'
])

export const commonMethods = mapActions('common', [
  'fetchAllMunicipality',
  'fetchAllDeparment',
  'fetchAllCountry',
  'fetchAllFlags',
  'fetchAllMasters'
])

// Periodic tasks helpers
// export const periodicTasksMethods = mapActions('periodicTasks', [
//   'fetchPeriodicTasks',
//   'createUpdatePeriodicTasks',
//   'deletePeriodicTasks',
//   'fetchPeriodicTasksDetail',
//   'fetchPeriodicTasksOptions',
//   'getLiveResultsPeriodicTasks',
//   'executeManuallyPeriodicTasks',
// ])

// export const periodicTasksResultsMethods = mapActions('periodicTasksResults', [
//   'fetchPeriodicTasksResults',
//   'createUpdatePeriodicTasksResults',
//   'deletePeriodicTasksResults',
//   'fetchPeriodicTasksResultsDetail',
// ])

// export const periodicTasksSolarScheduleMethods = mapActions(
//   'periodicTasksSolarSchedule',
//   [
//     'fetchPeriodicTasksSolarSchedule',
//     'createUpdatePeriodicTasksSolarSchedule',
//     'deletePeriodicTasksSolarSchedule',
//     'fetchPeriodicTasksSolarScheduleDetail',
//   ]
// )

// export const periodicTasksIntervalScheduleMethods = mapActions(
//   'periodicTasksIntervalSchedule',
//   [
//     'fetchPeriodicTasksIntervalSchedule',
//     'createUpdatePeriodicTasksIntervalSchedule',
//     'deletePeriodicTasksIntervalSchedule',
//     'fetchPeriodicTasksIntervalScheduleDetail',
//   ]
// )

// export const periodicTasksClockedScheduleMethods = mapActions(
//   'periodicTasksClockedSchedule',
//   [
//     'fetchPeriodicTasksClockedSchedule',
//     'createUpdatePeriodicTasksClockedSchedule',
//     'deletePeriodicTasksClockedSchedule',
//     'fetchPeriodicTasksClockedScheduleDetail',
//   ]
// )

// export const periodicTasksCrontabScheduleMethods = mapActions(
//   'periodicTasksCrontabSchedule',
//   [
//     'fetchPeriodicTasksCrontabSchedule',
//     'createUpdatePeriodicTasksCrontabSchedule',
//     'deletePeriodicTasksCrontabSchedule',
//     'fetchPeriodicTasksCrontabScheduleDetail',
//   ]
// )
